
import {
  Component,
  OnInit,
  AfterViewInit
}                                from '@angular/core';

import {
  Router,
  ActivatedRoute,
  ParamMap, Params
} from '@angular/router';

import {
  FormBuilder,
  FormGroup,
  Validators
}                                from '@angular/forms';

import { first                 } from 'rxjs/operators';

import { Logger                } from '@/util/logger';
import { AuthenticationService } from '@/services/authentication.service';
import { AlertService          } from '@/services/alert.service';
import { getUrlParams }          from '@/util/util';

import { environment } from '../../environments/environment';

@Component({
  standalone: false,
  templateUrl: 'logout.component.html'
})

/**
 *
 * @class LoginComponent
 *
 * @brief we show the login page when there is no established user session
 *
 * Angular tutorial on login / registration.
 * @link https://jasonwatmore.com/post/2018/10/29/angular-7-user-registration-and-login-example-tutorial#app-component-html
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class LogoutComponent implements OnInit, AfterViewInit {

  /** use a rand background image for the page */
  public backgrounds: string[] = ['rail1-1280x720.png', 'rail2-1280x720.png', 'rail3-1280x720.png', 'rail4-1280x720.png'];
  public background: string    = '';

  /** the external links for jumping to an OAuth delegated login */
  public google_sso: string    = environment.google_sso;
  public microsoft_sso: string = environment.microsoft_sso;

  /** form validation */
  public loginForm: FormGroup;

  /** flag to tell the form when we are processing */
  public loading:   boolean   = false;

  /* flag to tell the form that we completed an authentication request */
  public submitted: boolean   = false;

  /** where to return to once authenticated */
  public returnUrl: string    = '/';

  /** when we finalize SSO login, we have to authenticate with a one-time code instead of userid/password */
  public authCode: string = '';

  /** if we get redirected to login, *and* we had query parameters, try to pass 'em along */
  public queryParams: any;

  /** standard constructor */
  constructor(
    private route:        ActivatedRoute,
    private router:       Router,
    private auth:         AuthenticationService
  ) {

    /* pick a random background */

    this.background = this.backgrounds[Math.floor(Math.random() * this.backgrounds.length)];


  }

  /** on page setup, create the form validator */
  ngOnInit() {

    Logger.debug('[Logout] init...');


  }

  ngAfterViewInit() {

    Logger.debug('[Logout] after view init, signing out...');

    this.auth.logout();

    Logger.debug('[Logout] redirecting back to login page...');

    this.router.navigate(['/login']);
  }

}
